import { logError } from "src/shared/logError";

export enum Events {
    dismissed = 'Vibes.CustomerDismissed',
    submitted = 'Vibes.CustomerSubmitted',
    formWillShow = 'Vibes.UI.SurveyFormWillShow',
    formWasShown = 'Vibes.UI.SurveyFormWasShown',
    eligible = 'Vibes.UI.CustomerIsEligible',
    notEligible = 'Vibes.UI.CustomerIsNotEligible',
    formOffScreen = 'Vibes.UI.FormOffScreen',
    targetingDecisionFromCache = 'Vibes.UI.DecisionFromCache',
    targetingDecisionFromAPI = 'Vibes.UI.DecisionFromAPI',
    refusedToTarget = 'Vibes.UI.RefusedToTarget',
}

/**
 * This class is responsible for communicating with the Vibes event endpoints
 * to save events
 */
export class EventService {
    private readonly host: string;
    private readonly csrfToken: string;

    constructor(host: string, csrfToken = '') {
        this.host = host;
        this.csrfToken = csrfToken;
    }

    async saveEvent(eventName: Events, workflow: string) {
        const res = await fetch(`${this.host}/gp/vibes/api/events`, {
           method: 'POST',
           redirect: 'error',
           headers: {
               'Accept': "application/json",
               'Content-Type': 'application/json',
               'anti-csrftoken-a2z': this.csrfToken,
               'X-Requested-With': 'XMLHttpRequest', // MONS marks requests with this header as AJAX requests and handles things differently.
           },
           body: JSON.stringify({
               workflow,
               eventName
           })
        });

        // Fail gracefully, but log the error
        if (!res.ok) {
            logError("Error saving Event to Vibes API", `Unable to save event ${eventName} for workflow ${workflow}`);
        }
    }
}